export class SearchStatus {

    public hasResults: boolean = false;

    public recordCount: number = 0;

    public message: string;
}
